import { LegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'

const getContractTypeId = (contractVersion: ContractVersion) => {
  switch (contractVersion.attributes.country) {
    case 'de':
      return contractVersion.get('de_contract_type_id')
    case 'es':
      return contractVersion.get('es_contract_type_id')
    case 'fr':
      return contractVersion.get('fr_contract_type_id')
    case 'pt':
      return contractVersion.get('pt_contract_type_id')
  }

  return null
}

const getCountryContractTypes = (country: string, contractData: LegalEntityContractData) => {
  switch (country) {
    case 'de':
      return contractData.germanContractData.contractTypes
    case 'es':
      return contractData.spanishContractData.contractTypes
    case 'fr':
      return contractData.frenchContractData.contractTypes
    case 'pt':
      return contractData.portugueseContractData.contractTypes
  }
}

export const getContractType = (
  contractVersion: ContractVersion,
  contractData: LegalEntityContractData
) => {
  const contractTypes = getCountryContractTypes(
    contractVersion.attributes.country || '',
    contractData
  )
  if (!contractTypes) return ''
  const type = contractTypes.find((type) => type.id === getContractTypeId(contractVersion))
  return type ? type.name : ''
}
